class PriceRange extends HTMLElement {

  constructor() {
    super();
    console.log(this);
    this.min = Number(this.dataset.min);
    this.max = Number(this.dataset.max);
    this.track = this.querySelector(".price-range__track");
    this.handles = [...this.querySelectorAll(".price-range__thumbs")];
    this.startPos = 0;
    this.activeHandle;

    this.handles.forEach(handle => {
      handle.addEventListener('touchstart', this.startMove.bind(this));
      handle.addEventListener("mousedown", this.startMove.bind(this));
    })

    window.addEventListener("mouseup", this.stopMove.bind(this));
    window.addEventListener('touchend', this.stopMove.bind(this));

    this.querySelectorAll('input').forEach(
      element => element.addEventListener('change', this.onRangeChange.bind(this))
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  startMove(e) {
    // https://stackoverflow.com/questions/17130940/retrieve-the-same-offsetx-on-touch-like-mouse-event
    
    this.startPos = e.offsetX;
    if(typeof this.startPos === 'undefined'){
      this.startPos = e.targetTouches[0].clientX - e.target.getBoundingClientRect().x;
    }
    this.activeHandle = e.target;
    this.moveListener = this.move.bind(this);
    window.addEventListener("mousemove", this.moveListener);
    window.addEventListener('touchmove', this.moveListener);
  }

  move(e) {
    console.log(e);
    const isLower = this.activeHandle.classList.contains("is-lower");
    const property = isLower ? "--progress-lower" : "--progress-upper";
    const parentRect = this.track.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let clientX = e.clientX;
    if(typeof clientX === 'undefined'){
      clientX = e.targetTouches[0].clientX;
    }
    let newX = clientX - parentRect.x - this.startPos;

    if (isLower) {
      const otherX = parseInt(this.style.getPropertyValue("--progress-upper"));
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.min(newX, percentageX - handleRect.width);
      newX = Math.max(newX, 0 - handleRect.width / 2);
    }
    else {
      const otherX = parseInt(this.style.getPropertyValue("--progress-lower"));
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.max(newX, percentageX);
      newX = Math.min(newX, parentRect.width - handleRect.width / 2);
    }

    const percentage = (newX + handleRect.width / 2) / parentRect.width;
    const valuenow = this.calcHandleValue(percentage);
    this.style.setProperty(property, percentage * 100 + "%");
    this.activeHandle.ariaValueNow = valuenow;

    const output = this.activeHandle.nextElementSibling;
    const text = output.querySelector('.price-range__output-text');
    text.innerHTML = valuenow;

    const inputs = document.querySelectorAll('.collection-filters__price-range-form .collection-filters__filter-range input');
    const input = isLower ? inputs[0] : inputs[1];
    input.value = valuenow;

    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
  }

  calcHandleValue(percentage) {
    return Math.round(percentage * (this.max - this.min) + this.min);
  }

  stopMove() {
    window.removeEventListener("mousemove", this.moveListener);
    window.addEventListener('touchmove', this.moveListener);
    const form = this.closest('form');

    if (this.activeHandle && form) {
    document.querySelector('.collection-filters__price-range-form .collection-filters__filter-range input').dispatchEvent(new Event('change'));
    }
  }

  setMinAndMaxValues() {
    const inputs = document.querySelectorAll('.collection-filters__price-range-form .collection-filters__filter-range input');

    console.log(inputs)
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);



// THIS IS THE RANGE SLIDER LOGIC DO NOT CHANGE !!
var ZBRangeSlider = function (id) {
  var self = this;
  var startX = 0, x = 0;
  // retrieve touch button
  var slider = document.getElementById(id)
  var touchLeft = slider.querySelector('.slider-touch-left');
  var touchRight = slider.querySelector('.slider-touch-right');
  var lineSpan = slider.querySelector('.slider-line span');
  // get some properties
  var min = parseFloat(slider.getAttribute('se-min'));
  var max = parseFloat(slider.getAttribute('se-max'));
  // retrieve default values
  var defaultMinValue = min;
  if (slider.hasAttribute('se-min-value')) {
    defaultMinValue = parseFloat(slider.getAttribute('se-min-value'));
  }
  var defaultMaxValue = max;
  if (slider.hasAttribute('se-max-value')) {
    defaultMaxValue = parseFloat(slider.getAttribute('se-max-value'));
  }
  // check values are correct
  if (defaultMinValue < min) {
    defaultMinValue = min;
  }
  if (defaultMaxValue > max) {
    defaultMaxValue = max;
  }
  if (defaultMinValue > defaultMaxValue) {
    defaultMinValue = defaultMaxValue;
  }
  var step = 0.0;
  if (slider.getAttribute('se-step')) {
    step = Math.abs(parseFloat(slider.getAttribute('se-step')));
  }
  // normalize flag
  var normalizeFact = 10;
  self.slider = slider;
  self.reset = function () {
    touchLeft.style.left = '0px';
    touchRight.style.left = (slider.offsetWidth - touchLeft.offsetWidth) + 'px';
    lineSpan.style.marginLeft = '0px';
    lineSpan.style.width = (slider.offsetWidth - touchLeft.offsetWidth) + 'px';
    startX = 0;
    x = 0;
  };
  self.setMinValue = function (minValue) {
    var ratio = ((minValue - min) / (max - min));
    console.log(Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact))));
    touchLeft.style.left = Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact))) + 'px';
    lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px';
    lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px';
    slider.setAttribute('se-min-value', minValue);
  }
  self.setMaxValue = function (maxValue) {
    var ratio = ((maxValue - min) / (max - min));
    
    console.log(Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact)) + normalizeFact));
    touchRight.style.left = Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact)) + normalizeFact) + 'px';
    lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px';
    lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px';
    slider.setAttribute('se-max-value', maxValue);
  }
  // initial reset
  self.reset();
  // usefull values, min, max, normalize fact is the width of both touch buttons
  var maxX = slider.offsetWidth - touchRight.offsetWidth;
  var selectedTouch = null;
  var initialValue = (lineSpan.offsetWidth - normalizeFact);
  // set defualt values
  self.setMinValue(defaultMinValue);
  self.setMaxValue(defaultMaxValue);
  // setup touch/click events
  function onStart(event) {
    // Prevent default dragging of selected content
    event.preventDefault();
    var eventTouch = event;
    if (event.touches) {
      eventTouch = event.touches[0];
    }
    if (this === touchLeft) {
      x = touchLeft.offsetLeft;
    }
    else {
      x = touchRight.offsetLeft;
    }
    startX = eventTouch.pageX - x;
    selectedTouch = this;
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onStop);
    document.addEventListener('touchmove', onMove);
    document.addEventListener('touchend', onStop);
  }
  function onMove(event) {
    var eventTouch = event;
    if (event.touches) {
      eventTouch = event.touches[0];
    }
    x = eventTouch.pageX - startX;
    if (selectedTouch === touchLeft) {
      if (x > (touchRight.offsetLeft - selectedTouch.offsetWidth)) {
        x = (touchRight.offsetLeft - selectedTouch.offsetWidth)
      }
      else if (x < 0) {
        x = 0;
      }
      selectedTouch.style.left = x + 'px';
    }
    else if (selectedTouch === touchRight) {
      if (x < (touchLeft.offsetLeft + touchLeft.offsetWidth)) {
        x = (touchLeft.offsetLeft + touchLeft.offsetWidth)
      }
      else if (x > maxX) {
        x = maxX;
      }
      selectedTouch.style.left = x + 'px';
    }
    // update line span
    lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px';
    lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px';
    // write new value
    calculateValue();
    // call on change
    if (slider.getAttribute('on-change')) {
      var fn = new Function('min, max', slider.getAttribute('on-change'));
      fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
    }
    if (self.onChange) {
      self.onChange(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
    }
  }
  function onStop(event) {
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onStop);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', onStop);
    selectedTouch = null;
    // write new value
    calculateValue();
    // call did changed
    if (slider.getAttribute('did-changed')) {
      var fn = new Function('min, max', slider.getAttribute('did-changed'));
      fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
    }
    if (self.didChanged) {
      self.didChanged(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'));
    }
    document.querySelector('[name="filter.v.price.gte"]').dispatchEvent(new Event('change'));
  }
  function calculateValue() {
    var newValue = (lineSpan.offsetWidth - normalizeFact) / initialValue;
    var minValue = lineSpan.offsetLeft / initialValue;
    var maxValue = minValue + newValue;
    var minValue = minValue * (max - min) + min;
    var maxValue = maxValue * (max - min) + min;
    console.log(step);
    if (step !== 0.0) {
      var multi = Math.floor((minValue / step));
      minValue = step * multi;
      multi = Math.floor((maxValue / step));
      maxValue = step * multi;
    }
    slider.setAttribute('se-min-value', minValue);
    slider.setAttribute('se-max-value', maxValue);
  }
  // link events
  touchLeft.addEventListener('mousedown', onStart);
  touchRight.addEventListener('mousedown', onStart);
  touchLeft.addEventListener('touchstart', onStart);
  touchRight.addEventListener('touchstart', onStart);
};
let initPriceSlider = ()=>{
  let priceFilter = document.querySelector('.modal--productgrid-filters .price-filter');
  priceFilter?.addEventListener('click', initZBRangeSlider);
  function initZBRangeSlider(){
      setTimeout(()=>{
        var newRangeSlider = new ZBRangeSlider('my-slider');
        newRangeSlider.onChange = function (min, max) {
          console.log(min, max, this);
          document.getElementById('result').innerHTML = 'Min: ' + min + ' Max: ' + max;
          document.getElementById('left-value').innerHTML = min;
          document.getElementById('right-value').innerHTML = max;
        }
        newRangeSlider.didChanged = function (min, max) {
          console.log(min, max, this);
          document.getElementById('result').innerHTML = 'Min: ' + min + ' Max: ' + max;
        }
        priceFilter.removeEventListener('click', initZBRangeSlider);  
      },100)
  }
};